/* Variables created in rs-product-stock.liquid
- variants -> list with all the product variants
- productHandle -> the current product handle
*/
$(document).ready(function() {
	$("button[name='addToCartButton'").on("click", function() {
    	 try{
           		let inventory;
    			var variantId = $(this).attr("id").split("_")[1];
             	let quantity = parseInt(document.getElementById(`quantity_${variantId}`).value);
    			var option = {};	
    			var optionList = [];
    			var values = document.querySelectorAll(`#text_variant_${variantId}`);
    			var photos = document.querySelectorAll(`#img_variant_${variantId}`);
    			for (let i = 0; i < values.length; i++){
      				option.Text = values[i].textContent;
      				for( r = 0; r < photos.length; r++){
        				option.Photo = photos[r].alt == option.Text ? photos[r].src : option.Photo;}
    				optionList.push(option);
        			option = {};
    				}
           		if (document.getElementById(`inventory${variantId}`) != null){
                inventory = parseInt(document.getElementById(`inventory${variantId}`).value);}
      			if(inventory < quantity ){
          		throw `There are ${inventory} products left in stock.`
    			}
        		else if(quantity < 1 || isNaN(quantity)){
       			 throw `Enter a correct number.`
      			}
    
   
    CartJS.addItem(variantId, quantity, optionList, {
    	"success": function(data, textStatus, jqXHR) 
      {
    	window.location.assign("/cart");
      },
      "error": function(jqXHR, textStatus, errorThrown) {
        console.log('Error: ' + errorThrown + '!');
      }
    });

         
}catch(error){console.log(error)
document.getElementById(`mensage${variantId}`).innerHTML=error ;}
  
  });});

      
$("button[name='quantityAddition'").on("click", function() {
  var variantId = $(this).attr("id").split("_")[1];
  document.getElementById(`quantity_${variantId}`).value++;

});

$("button[name='quantitySubtraction'").on("click", function() {
  var variantId = $(this).attr("id").split("_")[1];
  if (document.getElementById(`quantity_${variantId}`).value > 0){
    document.getElementById(`quantity_${variantId}`).value--
    ;}
  
});